import React from "react";

export const DecisionGroup = ({ icon: Icon, title, options, selected, setSelected, testidPrefix,
                                hordeSize, sliderValue, setSliderValue,
                                customValue, setCustomValue }) => (
  <div>
    <div className="flex items-center gap-2 mb-3">
      <Icon className="w-4 h-4 text-blood" />
      <span className="tac-label">{title}</span>
    </div>
    <div className="space-y-2">
      {options.map((o) => {
        const locked = o.min_horde && hordeSize !== undefined && hordeSize < o.min_horde;
        const active = selected?.key === o.key;
        const showSlider = active && o.slider && hordeSize > 1 && setSliderValue;
        const showCustom = active && o.custom && setCustomValue;
        const maxForce = Math.max(1, hordeSize - 1);
        return (
          <div key={o.key}>
            <button
              disabled={locked}
              onClick={() => setSelected(o)}
              className={`tactical-card text-left w-full p-3 transition-all
                ${active ? "border-blood bg-[#0F0707]" : ""}
                ${locked ? "opacity-30 cursor-not-allowed" : "hover:border-blood"}`}
              data-testid={`${testidPrefix}-${o.key}`}
            >
              <div className="flex items-baseline justify-between gap-2">
                <p className="font-mono text-sm text-bone">{o.label}</p>
                {!locked && typeof o.success_pct === "number" && (
                  <span className={`font-mono text-[0.7rem] tabular-nums tracking-wider shrink-0 ${
                    o.success_pct >= 65 ? "text-[#7FBA9D]" :
                    o.success_pct >= 40 ? "text-bone" :
                    "text-blood"
                  }`}
                  data-testid={`${testidPrefix}-${o.key}-success`}>
                    {o.success_pct}%
                  </span>
                )}
              </div>
              <p className="text-[0.7rem] text-muted-h mt-1 leading-relaxed">
                {locked ? `LOCKED — needs ${o.min_horde}+ horde` : o.intel}
              </p>
            </button>
            {showSlider && (
              <div className="border border-blood border-t-0 px-3 py-3 bg-[#0F0707]"
                   data-testid={`${testidPrefix}-${o.key}-slider-panel`}>
                <div className="flex items-baseline justify-between mb-2 font-mono">
                  <span className="text-[0.65rem] tracking-[0.18em] text-muted-h">
                    BRING WITH YOU
                  </span>
                  <span className="text-bone text-base" data-testid="rally-slider-value">
                    {sliderValue} / {hordeSize}
                  </span>
                </div>
                <input
                  type="range"
                  min={1}
                  max={maxForce}
                  value={Math.min(sliderValue || 1, maxForce)}
                  onChange={(e) => setSliderValue(parseInt(e.target.value, 10))}
                  className="w-full accent-[var(--blood)] cursor-pointer"
                  data-testid="rally-slider"
                />
                <div className="flex justify-between mt-1 text-[0.65rem] font-mono text-muted-h">
                  <span data-testid="rally-stay-back">
                    Stay with main horde: <span className="text-bone">{hordeSize - sliderValue}</span>
                  </span>
                  <span data-testid="rally-march">
                    Marching with you: <span className="text-bone">{sliderValue}</span>
                  </span>
                </div>
              </div>
            )}
            {showCustom && (
              <div className="border border-blood border-t-0 px-3 py-3 bg-[#0F0707]"
                   data-testid={`${testidPrefix}-${o.key}-custom-panel`}>
                <p className="text-[0.65rem] tracking-[0.18em] text-muted-h font-mono mb-2">
                  WHISPER YOUR PLAN — THE SQUAD LEADER LISTENS
                </p>
                <textarea
                  value={customValue}
                  onChange={(e) => setCustomValue(e.target.value.slice(0, 300))}
                  placeholder="e.g. I drag a wounded zombie through the wire to draw their fire while I crawl in the opposite ditch and bite the captain from below."
                  rows={3}
                  className="w-full bg-[#080404] border border-blood/50 text-bone font-mono text-sm p-2 leading-relaxed resize-none focus:outline-none focus:border-blood placeholder:text-muted-h/50"
                  data-testid="custom-tactic-input"
                />
                <div className="flex justify-between mt-1 text-[0.6rem] font-mono text-muted-h">
                  <span>Clever earns trust. Stupid costs zombies.</span>
                  <span data-testid="custom-tactic-charcount">{customValue.length}/300</span>
                </div>
              </div>
            )}
          </div>
        );
      })}
    </div>
  </div>
);
